module.exports = __webpack_public_path__ + "static/media/EIGHT.ca30a63c.png";